'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.properties = exports.end = undefined;

var _end = require('./end');

var _end2 = _interopRequireDefault(_end);

var _properties = require('./properties');

var _properties2 = _interopRequireDefault(_properties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.end = _end2.default;
exports.properties = _properties2.default;
exports.default = { end: _end2.default, properties: _properties2.default };


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/transition/index.js
// module id = 339
// module chunks = 0